(function () {
  const selector = '[data-scarlet-shipping-message]';

  function formatMoney(cents) {
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      return window.theme.formatMoney(cents, window.theme.moneyFormat).replace('.00', '');
    }

    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function renderMessage(message, total) {
    const limit = Number(message.dataset.limit || 0);
    const text = message.querySelector('[data-scarlet-shipping-text]');
    const progress = message.querySelector('[data-cart-progress]');

    if (!text || !limit) return;

    message.dataset.cartTotalPrice = String(total);
    message.classList.toggle('is-hidden', total <= 0);

    const qualified = total >= limit;
    message.classList.toggle('is-success', qualified);

    if (qualified) {
      text.textContent = message.dataset.qualifiedMessage || 'Free shipping unlocked';
    } else {
      const remaining = formatMoney(Math.max(0, limit - total));
      text.textContent = (message.dataset.remainingTemplate || 'You are ||amount|| away from free shipping')
        .replace('||amount||', remaining);
    }

    if (progress) {
      const percent = Math.max(0, Math.min((total / limit) * 100, 100));
      progress.dataset.percent = String(percent);
      progress.style.setProperty('--percent', String(percent));
    }
  }

  function updateFromCart(cart) {
    document.querySelectorAll(selector).forEach(function (message) {
      renderMessage(message, Number(cart.total_price || 0));
    });
  }

  function refresh() {
    if (!document.querySelector(selector)) return;

    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load cart');
        return response.json();
      })
      .then(updateFromCart)
      .catch(function (error) {
        console.warn('Scarlet free-shipping message could not refresh:', error);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }

  document.addEventListener('theme:cart:change', refresh);
  document.addEventListener('theme:product:added', refresh);
})();